// src/components/Header.js
import React from 'react';
import '../css/Header.css';
import { ThemeToggleButton, FilterToggleButton } from './Buttons';
import FilterControls from './FilterControls';

export default function Header({
  theme,
  onToggleTheme,
  showFilters,
  onToggleFilters,
  query,
  onQueryChange,
  phaseFilters,
  onTogglePhase,
  ltsOnly,
  onToggleLts
}) {
  return (
    <header className="app-header">
      <center>        <a href="https://www.spaghetticodejungle.com/">
          <img
            src="/images/spj_logo.png"
            alt="Spaghetti Code Jungle Logo"
            width="80"
          />
        </a></center>
      <div className="header-actions">
        <ThemeToggleButton theme={theme} onToggleTheme={onToggleTheme} />
        <FilterToggleButton
          onToggleControls={onToggleFilters}
          aria-label={showFilters ? 'Hide filters' : 'Show filters'}
        />
      </div>
      <center>{showFilters && (
        <FilterControls
          query={query}
          onQueryChange={onQueryChange}
          phaseFilters={phaseFilters}
          onTogglePhase={onTogglePhase}
          ltsOnly={ltsOnly}
          onToggleLts={onToggleLts}
        />
      )}</center>
      <h1>Java Versions & Features</h1>
    </header>
  );
}
